import React, { useState, useEffect } from "react";
import "./case.css";
import Dropdown from "react-dropdown";
import { toast } from "react-toastify";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { Link, useNavigate } from "react-router-dom";
import { width } from "@mui/system";

function Case() {
  const options = [
    "Divorce",
    "Child Custody",
    "Adoption",
    "Conflicts",
    "Spousal neglect",
    "Dowry",
  ];
  let [price, setPrice] = useState("");
  let [Lawyersarr, setLawyersarr] = useState([]);
  useEffect(() => {
    const db = getDatabase();
    const starCountRef = ref(db, "/lawyer");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        arr.push(element.val());
      });
      setLoading(false)
      setLawyersarr(arr);
    });
  }, []);
  let [loading, setLoading] = useState(false);
  let [select, setSelect] = useState("");
  let [select1, setSelect1] = useState("");

  let [SubOption, setSubOption] = useState([]);
  let [subType, setSubType] = useState(false);
  let [selectedValue, setselectedValue] = useState({});
  let SetSubCatagorie = (select) => {
    if (select == "Divorce") {
      setSubOption(["unemployment", "Mental Health Issues"]);
      return;
    }

    if (select == "Child Custody") {
      setSubOption(["Parents Are not Stable", "Conflicts"]);
      return;
    }

    if (select == "Adoption") {
      setSubOption(["Childlessness", "Orphanism"]);
      return;
    }

    if (select == "Conflicts") {
      setSubOption(["Abusing", "Defaunded"]);
      return;
    }

    if (select == "Spousal neglect") {
      setSubOption(["Infedility", "Misbehave"]);
      return;
    }

    if (select == "Dowry") {
      setSubOption(["Gender Inequality", "Lack Of Education"]);
      return;
    }
  };

  let returnFilter = (e) => {
    console.log(e);
    return price.length > 0
      ? JSON.parse(e.price) >= JSON.parse(price) &&
          e.category.includes(select) == true
      : e.category.includes(select) == true;
  };
  let arr = sortArray(Lawyersarr.filter((e) => returnFilter(e)));
  console.log(arr);

  function sortArray(array) {
    var temp = 0;
    for (var i = 0; i < array.length; i++) {
      for (var j = i; j < array.length; j++) {
        let feed1 =
          (5 * array[j].Star5 +
            4 * array[j].Star4 +
            3 * array[j].Star3 +
            2 * array[j].Star2 +
            1 * array[j].Star1) /
          array[j].TotalRatings;

        let feed2 =
          (5 * array[i].Star5 +
            4 * array[i].Star4 +
            3 * array[i].Star3 +
            2 * array[i].Star2 +
            1 * array[i].Star1) /
          array[i].TotalRatings;

        if (isNaN(feed1)) {
          feed1 = 0;
        }

        if (isNaN(feed2)) {
          feed2 = 0;
        }
        if (feed1 > feed2) {
          temp = array[j];
          array[j] = array[i];
          array[i] = temp;
        }
      }
    }
    return array;
  }
  let SendQuery = (value) => {
    function makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }

    let key = makeid(24);
    console.log(key);
    const db = getDatabase();

    set(ref(db, "requests/" + key), {
      Layer_name: value.first_name + " " + value.last_name,
      laywer_email: value.email,
      client_name: sessionStorage.getItem("LoginName"),
      client_email: sessionStorage.getItem("email"),
      approved: "Not Approved",
      business_Uid: value.uid,
      coustomer_uid: sessionStorage.getItem("uid"),
      uid: key,
      Feedback: "no",
      Star: 0,
      Type_select:select,
      subType_Select:select1,
      response:'no'
    }).then(() => {
      toast.success("Your Query Send Sucessfully");
      window.location.href = "/cases/#";
    });
  };
  return (
    <>
      <div className="container ht">
        <h1 className="case">Welcome To Lawyers Online</h1>
        <em className="emp">
          we have best lawyers for your case <br />
          Enter Your Case Below
          <i class="material-icons">get_app</i>
        </em>
      </div>

      <div className="container qry">
        <div className="row">
          <Dropdown
            options={options}
            placeholder="Select Type"
            onChange={(e) => {
              setSelect(e.value);
              SetSubCatagorie(e.value);
              setSubType(true);
              setSelect1('')
                     }}
            className="myClassName"
          />
          <br></br>
          <br></br>
          {subType ? (
            <>
              <Dropdown
                options={SubOption}
                value={select1}
                placeholder="Select Sub Type"
                onChange={(e) => {
                  setSelect1(e.value)
                  setLoading(true)
                  setTimeout(() => {
                    setLoading(false)
                  }, 1000);
                }}
                className="myClassName"
                id="2ndOne"
              />
              <br></br>

              <input
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
                placeholder="Enter you Budget"
              ></input>
            </>
          ) : null}
          <br></br> <br></br>
          <br></br>
        </div>

        <div className="mainFlex">
         

          {loading ? 
          <img  src={require('../assets/loading.gif')}></img> :
          
          <>
           {subType && select1.length>0
            ? arr.map((v, i) => {
                if (v.approved !== "no") {
                  return (
                    <a href="#popup1">
                      <div
                        key={i}
                        onClick={() => setselectedValue(v)}
                        class="product-grid"
                      >
                        <div class="product-image">
                          <img
                            // class="pic-1"
                            id="images_ALl"
                            style={{ marginLeft: 0 }}
                            src={v.dp}
                          />
                        </div>
                        <div className="title_div">
                          <div class="product-content">
                            <h3 class="title">
                              <a href="">{v.first_name + " " + v.last_name}</a>
                            </h3>
                            <div class="price">Rs. {v.price}</div>
                          </div>
                          <div>
                            <div className="flex">
                              {v.TotalRatings > 0 ? (
                                <>
                                  {(5 * v.Star5 +
                                    4 * v.Star4 +
                                    3 * v.Star3 +
                                    2 * v.Star2 +
                                    1 * v.Star1) /
                                    v.TotalRatings}
                                  <img
                                    style={{
                                      width: 15,
                                      height: 15,
                                      margin: 0,
                                      padding: 0,
                                      marginTop: -5,
                                    }}
                                    src="https://www.freepnglogos.com/uploads/star-png/star-vector-png-transparent-image-pngpix-21.png"
                                  ></img>
                                </>
                              ) : null}{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  );
                }
              })
            : null}</>
          
          }
        </div>
      </div>

      <div id="popup1" class="overlay">
        <div class="popup">
          <img
            // class="pic-1"
            id="images_ALl"
            style={{ marginLeft: 0 }}
            src={selectedValue.dp}
          />
          <a class="close" href="#">
            &times;
          </a>
          <div class="content">
            <h4>{selectedValue.first_name + " " + selectedValue.last_name}</h4>

            <h5>{selectedValue.email}</h5>

            <h5>Min Price : {selectedValue.price}pkr</h5>

            <button
              onClick={() => SendQuery(selectedValue)}
              className="btn btn-danger"
            >
              Hire ME
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Case;
